import { Box, TextField, Typography } from '@mui/material';

/** Renders a labeled row of extracted data, or nothing if the value is empty. */
export function InfoRow({ label, value }: { label: string; value: string | null | undefined }) {
  if (!value) return null;
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Box>
  );
}

/** Editable text row for edit mode. */
export function EditableRow({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (val: string) => void;
}) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <TextField
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
        size="small"
        variant="outlined"
      />
    </Box>
  );
}

/** Human-readable label for the clinic_type value. */
export function clinicTypeLabel(clinicType: string | null): string | null {
  if (!clinicType) return null;
  const labels: Record<string, string> = {
    solo: 'Solo Practice',
    group: 'Group Practice',
    multi_location: 'Multi-Location Practice',
  };
  return labels[clinicType] ?? clinicType;
}
